import Constants from "../utils/consts";
import SqlString from "sqlstring";
var http = require("follow-redirects").https;
var qs = require("querystring");

export default async function sendMail(
  username,
  token,
  from,
  fromName,
  password,
  to,
  toName,
  attachmentPath,
  subject,
  body,
) {
  console.log("to", to);
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "sendMail.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);

        try {
          const resp = JSON.parse(body.toString());
          console.log("Risposta sendMail:", resp);

          if (resp.success === true) {
            resolve({
              success: true,
              message: resp.message || "Email inviata",
            });
          } else {
            console.error("Errore invio email:", resp.error);
            reject(
              new Error(resp.error || "Errore sconosciuto nell'invio email"),
            );
          }
        } catch (e) {
          // Se non è JSON valido, assume successo (retrocompatibilità)
          console.warn("Risposta non JSON da sendMail:", body.toString());
          resolve({ success: true, message: "OK" });
        }
      });

      res.on("error", function(error) {
        console.error("Errore HTTP sendMail:", error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      uname: username,
      token: token,
      from: from,
      fromName: fromName,
      password: password,
      to: to,
      cc: "",
      toName: toName,
      attachmentPath: attachmentPath,
      subject: subject,
      body: body,
    });

    req.write(postData);

    req.end();
  });
}
